import React, { Component } from "react";
import { Modal } from "semantic-ui-react";

class MentionsLegales extends Component {
  render() {
    return (
      <Modal
        style={{ top: "50%", left: "50%", margin: "20px" }}
        size="large"
        className="long modal test scrolling transition visible active"
        closeIcon
        trigger={
          <p style={{ cursor: "pointer" }} className="footer-link">
            Mentions Légales
          </p>
        }
      >
        <Modal.Header style={{ textAlign: "center" }}>
          Mentions Légales
        </Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description className="mentions-legales">
            <h2>Hébergement</h2>

            <p>
              Ce site est hébergé par OVH :
              <br />SAS au capital de 10 059 500 €
              <br />RCS Lille Métropole 424 761 419 00045
              <br />Code APE 6202A
              <br />N° TVA : FR 22 424 761 419
              <br />Siège social :
              <br />2 rue Kellermann
              <br />59100 Roubaix
              <br />France
            </p>

            <h2>Paraphe Online est un service proposé par CERTYTECH</h2>

            <p>
              Dénomination sociale : EURL Certytech
              <br />Capital : 5000.00 €
              <br />
              Adresse du siège social : 20 rue Lavoisier 35220 Chateaubourg
              <br />Adresse e-mail de contact : contact@certytech.com
              <br />Coordonnées téléphoniques : 09 72 54 34 37
              <br />Nom du directeur de publication : Barteau Vincent
            </p>

            <h2> Politique de confidentialité </h2>
            <p>
              <h3>POLITIQUE DE CONFIDENTIALITÉ</h3>
              <p>
                <br />Cette page web regroupe la Politique de Confidentialité de
                PARAPHE ONLINE, ces informations sont à utiliser lors de la mise
                en ligne de l’application mobile PARAPHE ONLINE mais ne s’y
                limite pas.
                <h3>INTRODUCTION</h3>
                <p>
                  <br />Devant le développement des nouveaux outils de
                  communication, il est nécessaire de porter une attention
                  particulière à la protection de la vie privée. C’est pourquoi,
                  nous nous engageons à respecter la confidentialité des
                  renseignements personnels que nous collectons.
                  <br />Avertissement : Le Site web/Application mobile
                  développés par PARAPHE ONLINE vous permettent uniquement de
                  générer et signer électroniquement des documents à l’aide de
                  formulaires personnalisables.
                </p>
                <h3>COLLECTE DES DONNÉES PERSONNELLES</h3>
                <p>
                  <br />Nous collectons les renseignements suivants :
                  <br />Nom/ Prénom
                  <br />Adresse postale
                  <br />Adresse électronique
                  <br />Numéro de téléphone
                  <br />
                  <br />Les données personnelles sont recueillies uniquement
                  après que vous nous ayez donné votre consentement, notamment
                  lors de votre première connexion. Les renseignements
                  personnels que nous collectons sont recueillis au travers de
                  formulaires et grâce à l’interactivité établie entre vous et
                  notre site Web/Application mobile. Vos données ne sont en
                  aucun cas transmisses à des partenaires de PARAPHE ONLINE.
                  Enfin, nous n’utilisons pas de cookies pour réunir des
                  informations vous concernant.
                </p>
                <h3>FICHIERS JOURNAUX</h3>
                <p>
                  <br />Lorsque vous utilisez notre Site web/Application mobile,
                  nous collectons et stockons des informations dans les fichiers
                  journaux de nos serveurs. Cela comprend :
                  <br />La façon dont vous avez utilisé le service concerné,
                  telles que vos requêtes de recherche.
                  <br />Votre adresse IP.
                  <br />Des données relatives aux événements liés à l’appareil
                  que vous utilisez, tels que plantages, activité du système,
                  paramètres du matériel, type et langue de votre navigateur,
                  date et heure de la requête et URL de provenance.
                </p>
                <h3>FORMULAIRES ET INTÉRACTIVITÉ</h3>
                <p>
                  <br />Vos renseignements personnels sont collectés par le
                  biais de formulaire, à savoir :
                  <br />Formulaire d’inscription au site Web/Application mobile
                  <br />Nous utilisons les renseignements ainsi collectés pour
                  les finalités suivantes :
                  <br />Statistiques
                  <br />Contact
                  <br />Gestion du site Web/Application mobile (présentation,
                  organisation)
                  <br />Vos renseignements sont également collectés par le biais
                  de l’interactivité pouvant s’établir entre vous et notre site
                  Web/Application mobile et ce, de la façon suivante :
                  <br />Contact
                  <br />Gestion du site Web/Application mobile (présentation,
                  organisation)
                  <br />Nous utilisons les renseignements ainsi collectés pour
                  les finalités suivantes :
                  <br />Correspondance
                  <br />Aucune publicité ou incitation commerciale n’est
                  présente sur notre Site Web/Application mobile.
                </p>
                <h3>DROIT D’OPPOSITION ET DE RETRAIT</h3>
                <p>
                  <br />Nous nous engageons à vous offrir un droit d’opposition
                  et de retrait quant à vos renseignements personnels.
                  <br />Le droit d’opposition s’entend comme étant la
                  possibilité offerte aux internautes de refuser que leurs
                  renseignements personnels soient utilisés à certaines fins
                  mentionnées lors de la collecte.
                  <br />Le droit de retrait s’entend comme étant la possibilité
                  offerte aux internautes de demander que leurs renseignements
                  personnels ne figurent plus, par exemple, dans une liste de
                  diffusion.
                  <br />Pour pouvoir exercer ces droits, vous pouvez nous
                  contacter par courrier à l’adresse :
                  <br />Certytech
                  <br />20 rue Lavoisier 35220 CHATEAUBOURG
                  <br />Téléphone : 0972543437
                </p>
                <h3>DROIT D’ACCÈS</h3>
                <br />Nous nous engageons à reconnaître un droit d’accès et de
                rectification aux personnes concernées désireuses de consulter,
                modifier, voire radier les informations les concernant.
                <br />L’exercice de ce droit se fera par courrier à l’adresse :
                <br />Certytech
                <br />20 rue Lavoisier 35220 CHATEAUBOURG
                <br />Téléphone : 0972543437
              </p>
              <h3>DIVULGATION D’INFORMATIONS PERSONNELLES</h3>
              <p>
                <br />Il peut nous arriver de transmettre vos informations
                personnelles à nos employés ou équipes techniques afin de gérer
                les comptes utilisateur, le site web/application mobile et les
                services qui vous sont proposés. Toute divulgation de données
                personnelles sera strictement contrôlée et réalisée en accord
                avec les législations européennes et américaines, mais aussi des
                pays depuis lesquels notre site web/application mobile est
                disponible.
                <br />Nous ne divulguons pas vos données personnelles à une
                tierce partie sans votre consentement et conformément à la loi
                en vigueur. Nous vous encourageons à consulter nos termes et
                conditions d’utilisation
              </p>
              <h3>SÉCURITÉ</h3>
              <p>
                <br />Les renseignements personnels que nous collectons sont
                conservés dans un environnement sécurisé. Les personnes
                travaillant pour nous sont tenues de respecter la
                confidentialité de vos informations. Pour assurer la sécurité de
                vos renseignements personnels, nous avons recours aux mesures
                suivantes :
                <br />Protocole SSL (Secure Sockets Layer)
                <br />Gestion des accès – personne autorisée
                <br />Gestion des accès – personne concernée
                <br />Logiciel de surveillance du réseau
                <br />Sauvegarde informatique
                <br />Développement de certificat numérique
                <br />Identifiant / mot de passe
                <br />Pare-feu (Firewalls)
                <br />Nous nous engageons à maintenir un haut degré de
                confidentialité en intégrant les dernières innovations
                technologiques permettant d’assurer la confidentialité de vos
                données. Toutefois, comme aucun mécanisme n’offre une sécurité
                maximale, une part de risque est toujours présente lorsque l’on
                utilise Internet pour transmettre des renseignements personnels.
              </p>
              <h3>LÉGISLATION</h3>
              <p>
                <br />Nous nous engageons à respecter les dispositions
                législatives énoncées dans :
                <br />Loi 78-17 Informatique et Libertés.
              </p>
              <h3>MISES À JOUR</h3>
              <br />Les présentes Règles de confidentialité peuvent être amenées
              à changer, nous publierons toute modification des règles de
              confidentialité sur cette page et une notification vous sera
              envoyée afin de vous inciter à consulter les nouvelles règles en
              vigueur
            </p>
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}

export default MentionsLegales;



// WEBPACK FOOTER //
// ./src/components/MentionsLegales.js